




























import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '~/utils/nuxt3-migration'
import { PingSize, PingVariant } from '~/models/app/ping'
import { ciTimes } from '~/icons/source/solid/times'
import { ciCheck } from '~/icons/source/solid/check'

export default defineComponent({
  props: {
    ping: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String as PropType<PingVariant>,
      default: null
    },
    size: {
      type: String as PropType<PingSize>,
      default: 'md'
    }
  },
  setup(props) {
    const { variant, size } = toRefs(props)

    const variantIsInfo = computed(() => variant.value === 'info')
    const variantIsSuccess = computed(() => variant.value === 'success')
    const variantIsDanger = computed(() => variant.value === 'danger')

    const circleStateClass = computed(() => {
      if (variantIsInfo.value) {
        return ['tw-bg-blue-100']
      } else if (variantIsSuccess.value) {
        return ['tw-bg-green-100']
      } else if (variantIsDanger.value) {
        return ['tw-bg-red-100']
      }
      return ['tw-bg-grey-200']
    })

    const pingClasses = computed(() => {
      if (variantIsInfo.value) {
        return ['tw-bg-blue-300']
      } else if (variantIsSuccess.value) {
        return ['tw-bg-green-300']
      } else if (variantIsDanger.value) {
        return ['tw-bg-red-300']
      }
      return ['tw-bg-grey-300']
    })

    const sizeClasses = computed(() => {
      if (size.value === 'sm') {
        return ['tw-h-4 tw-w-4']
      }
      return ['tw-h-5 tw-w-5']
    })

    return {
      variantIsInfo,
      variantIsSuccess,
      variantIsDanger,
      ciCheck,
      ciTimes,
      circleStateClass,
      pingClasses,
      sizeClasses
    }
  }
})
